import { useState } from 'react';
import tw from 'twin.macro';

import { ArrowPathIcon, CheckIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline';

import { Button, Input } from './base';

type ClipboardCopyInputProps = {
  url?: string;
  onRefreshUrl?: () => void;
  loading?: boolean;
};

const ExpiryLinkCopyInput: React.FC<ClipboardCopyInputProps> = (props) => {
  const { url, loading, onRefreshUrl = () => {} } = props;

  const [copied, setCopied] = useState<boolean>(false);

  const handlecopyToClipboard = () => {
    if (!url) return;
    setCopied(true);
    navigator.clipboard.writeText(url);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  return (
    <div tw="flex flex-nowrap">
      <Input
        tw="w-full rounded-r-none border bg-gray-50 py-2 px-3"
        value={url}
        readOnly
        disabled={loading}
      />
      <Button
        css={[
          tw`flex items-center gap-1 whitespace-nowrap rounded-none py-2 px-3 bg-blue-500 hover:bg-blue-600`,
        ]}
        onClick={onRefreshUrl}
        disabled={loading}
      >
        <>
          <ArrowPathIcon tw="h-5 w-5" />
        </>
      </Button>
      <Button
        css={[
          tw`flex items-center gap-1 whitespace-nowrap rounded-l-none py-2 px-3`,
          copied && tw`cursor-default bg-success-500 hover:bg-success-500`,
        ]}
        onClick={handlecopyToClipboard}
        disabled={loading}
      >
        {copied ? (
          <>
            <CheckIcon tw="h-5 w-5" />
            <span>คัดลอกแล้ว</span>
          </>
        ) : (
          <>
            <DocumentDuplicateIcon tw="h-5 w-5" />
            <span>คัดลอก</span>
          </>
        )}
      </Button>
    </div>
  );
};

export default ExpiryLinkCopyInput;
